// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rz8ian0px4JlshzVLsmWYQ\\=\\= {\n  width: 1rem;\n  fill: currentColor;\n}", "",{"version":3,"sources":["webpack://./src/pages/CommunityDetails/Posts/PostItem/MenuOwner/postActions/postActions.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".icon {\n  width: 1rem;\n  fill: currentColor;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "rz8ian0px4JlshzVLsmWYQ=="
};
export default ___CSS_LOADER_EXPORT___;
